 import React, { useState, Fragment, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { isUndefined } from "lodash";
import {
  NavItem,
  Nav,
} from "reactstrap";
import { Trans } from "react-i18next";
import EmployeeContext from "../../contexts/EmployeeContext";
import { useOrganisationContext } from "../../hooks/useOrganisationContext";
import { organisationIdState, collapsedSidebarState } from "../../atoms";
import { useSetRecoilState } from "recoil";
import { useUserContext } from "../../hooks";
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useRecoilState } from "recoil";
import LiItemDropdown from './LiItemDropdown';
import { all, any } from 'Helpers'
import { hrPerms, userAndSubsPerms } from "pages/PermissionsList";

const Sidebar = (props) => {

  let { isAdmin, isUser, isInTrialPeriod } = useUserContext();


  const [selectedSection, setSelectedSection] = React.useState('');

  const [collapsedSidebar, setCollapsedSidebar] = useRecoilState(collapsedSidebarState);

  const [hoverSidebar, setHoverSidebar] = React.useState(false);

  const [subscribedFeatures, setSubscribedFeatures] = useState({
    isAccounting: isInTrialPeriod,
    isWPConnect: isInTrialPeriod,
    isPayroll: isInTrialPeriod,
    isActive: isInTrialPeriod,
  })

  const NavLink = ({ to, test, ...props }) =>
    !isUndefined(test) && !test ? null : (
      <NavItem>
        <Link to={`/${to}`} {...props} className="nav-link" />
        {/* <Link to={`/${to}`} {...props} className="nav-link"  style={{ marginTop:"30px", marginLeft: "15px", color:"red"}}/> */}
      </NavItem>
    );

  // const setOrganisationId = useSetRecoilState(organisationIdState);
  const { employee } = useContext(EmployeeContext);
  const { selectedOrganisation, organisations } = useOrganisationContext();
  // const { data: contactGroups } = useContactGroupsQuery({
  //   useErrorBoundary: false,
  // });

  useEffect(() => {
    if (!isInTrialPeriod && selectedOrganisation?.subscribed_features) {
      let subFeatures = selectedOrganisation?.subscribed_features
      let accounting = subFeatures?.hesaabmodule?.includes('accounting')
      let wpconnect = subFeatures?.hesaabmodule?.includes('wpconnect')
      let payroll = subFeatures?.hesaabmodule?.includes('payroll')
      let active = accounting || wpconnect || payroll

      setSubscribedFeatures({
        isAccounting: accounting,
        isWPConnect: wpconnect,
        isPayroll: payroll,
        isActive: active,
      })
    }

  }, [selectedOrganisation,])

  const {
    isAccounting,
    isWPConnect,
    isPayroll,
    isActive,
  } = subscribedFeatures


  const switchCollapse = () => {
    setCollapsedSidebar(!collapsedSidebar)
    setHoverSidebar(false);
  }

  React.useEffect(() => {
    if (window.location.pathname.includes("employee_payroll")) {
      setSelectedSection("portal")
    } else if (window.location.pathname.includes("userslist") || window.location.pathname.includes("userspage")) {
      setSelectedSection("users")
    } else if (window.location.pathname.includes("payroll")) {
      setSelectedSection("payroll")
    } else if (window.location.pathname.includes("tasks")) {
      setSelectedSection("tasks")
    } else {
      setSelectedSection("accounting")
    }
  }, [window.location.pathname])



  const showMenuWhenCollapsed = () => {
    return
    if (collapsedSidebar === true) {
      setHoverSidebar(true);
      setCollapsedSidebar(false);
    }

  }

  const hideMenuWhenCollapsed = () => {
    // setCollapsedSidebar(collapsedSidebar);
    if (hoverSidebar === true) {
      setCollapsedSidebar(true);
      setHoverSidebar(false);

    }
  }

  return (
    <aside className="left-sidebar" id="sidebarbg" data-sidebarbg="skin6" style={collapsedSidebar === true ? { width: "60px" } : {}}>
      <div className="scroll-sidebar">
        <PerfectScrollbar className="sidebar-nav">
          <Nav id="sidebarnav"
            className={(collapsedSidebar === true ? 'fix-collapse-bar' : '')}
            style={{ display: "flex", flexDirection: "column" }}
            onMouseEnter={showMenuWhenCollapsed}
            onMouseLeave={hideMenuWhenCollapsed}
          >

            <NavLink to="admin-dashboard" test={isAdmin} style={{ marginTop: "25px" }}>
              <Trans>Dashboard</Trans>
            </NavLink>
            <NavLink to="customer_invoices" test={isAdmin} style={{ marginTop: "25px" }}>
              <Trans>Customer Invoices</Trans>
            </NavLink>
            <NavLink to="connect" test={isAdmin}>
              <Trans>Connect</Trans>
            </NavLink>
            <NavLink to="subscribers" test={isAdmin}>
              <Trans>Subscribers</Trans>
            </NavLink>
            <NavLink to="users" test={isAdmin}>
              <Trans>Users</Trans>
            </NavLink>
            <NavLink to="global_settings" test={isAdmin}>
              <Trans>Settings</Trans>
            </NavLink>
            <NavLink to="invoice_settings" test={isAdmin}>
              <Trans>Invoice Settings</Trans>
            </NavLink>
            <NavLink to="managegroups" test={isAdmin}>
              <Trans>Permissions Groups</Trans>
            </NavLink>
            <NavLink to="core/company" test={isAdmin}>
              <Trans>Company</Trans>
            </NavLink>
            <NavLink to="core/organisation" test={isAdmin}>
              <Trans>Organisation</Trans>
            </NavLink>
            <NavLink to="subscription/manage" test={isAdmin}>
              <Trans>Manage Subscriptions</Trans>
            </NavLink>
            <NavLink to="core/employees" test={isAdmin}>
              <Trans>{`Sales & Marketing`}</Trans>
            </NavLink>
            <NavLink to="announcements" test={isAdmin}>
              <Trans>Announcements</Trans>
            </NavLink>

            {/* {!!employee && (
              <NavLink to="employee_payroll">
                <Trans>Employee Payroll</Trans>
              </NavLink>
            )} */}
            {!isAdmin && (
              <Fragment>

                {/* {collapsedSidebar=== false ? <div className="nav-txt"><Trans>Dashboard</Trans></div> : ""}   */}
                <li>
                  <LiItemDropdown text="Overview " icon="dashboard" url="/home" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} />
                </li>
                {/* {!collapsedSidebar && 
                <li>
                <LiOrganisation organisations={organisations} selectedOrganisation={selectedOrganisation} />
              </li>
              } */}
                {isAccounting && (
                  <>
                    {selectedSection === "accounting" && (
                      <>
                        <li>
                          <LiItemDropdown text="Dashboard" icon="dashboard" url="/dashboard" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} access={['xero_account_dashboard']} />
                        </li>
                        <li>
                          <LiItemDropdown text="Organisation Stats" icon="dashboard" url="/organisation-stats" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} />
                        </li>

                        <li>
                          <LiItemDropdown text="Accounting" icon="accounts" url="/bank/bank_accounts" srcImg="/images/accounts-icon.svg" dropdown={true} childList={[
                            {
                              text: "Sales",
                              url: "/accounts_receivable",
                              access: ['xero_sales'],
                              func: all,

                            },
                            {
                              text: "Purchases",
                              url: "/purchases",
                              access: ['xero_purchases'],
                              func: all,

                            },
                            {
                              text: "Quotes",
                              url: "/quotes",
                              access: ['xero_quotes'],
                              func: all,
                            },
                            // {
                            //   text:"Expense Claims",
                            //   url:"/accounts_receivable/invoices/all",
                            //   access:['xero_access_invoices'],
                            //   func:all,
                            // },
                            {
                              text: "Bank Accounts",
                              url: "/bank/bank_accounts",
                              access: ['xero_bank-accounts', 'xero_accounts'],
                              func: any,
                            },
                            {
                              text: "Chart of accounts",
                              url: "/accounts/chart_of_accounts/all",
                              access: ['xero_chart-of-accounts', 'xero_accounts'],
                              func: any,

                            },
                            {
                              text: "Inventory",
                              url: "/inventory",
                              access: ['xero_inventory'],
                              func: all,
                            },
                            {
                              text: "Fixed Assets",
                              url: "/fixed-assets",
                              access: ['xero_inventory', 'xero_sales', 'xero_purchases', 'xero_settings'],
                              func: all,
                            },
                            {
                              text: "Manual Journals",
                              url: "/accounts/manual_journals/all",
                              access: ['xero_manual-journal_edit'],
                              func: all,
                            }
                          ]} />
                        </li>

                        <li>
                          <LiItemDropdown text="Reports" icon="reports" url="/reports/bank_summary" srcImg="/images/reports-icon.svg" dropdown={true} access={['xero_balance_sheet', 'xero_bank_summary', 'xero_budget_summary', 'xero_executive_summary', 'xero_payable_receivable', 'xero_profit_and_loss', 'xero_trial_balance', 'xero_trial_balance_movement', 'xero_sales_tax', 'zatca_tax_report']} childList={[
                            {
                              type:"SUB_MENU",
                              text: " Financial Overview",
                              access: ['xero_balance_sheet', 'xero_profit_and_loss', 'xero_trial_balance', 'xero_trial_balance_movement'],
                              func: any,
                              subChildList: [
                                {
                                  text: "Balance Sheet",
                                  url: "/reports/balance_sheet",
                                  access: ['xero_balance_sheet']
                                },
                                {
                                  text: "Profit And Loss",
                                  url: "/reports/profit_and_loss",
                                  access: ['xero_profit_and_loss'],
                                },
                                {
                                  text: "Trial Balance",
                                  url: "/reports/trial_balance",
                                  access: ['xero_trial_balance'],
                                },
                              ]
                            },

                            {
                              type:"SUB_MENU",
                              text: "Summary Reports",
                              access: ['xero_bank_summary', 'xero_budget_summary', 'xero_executive_summary'],
                              func: any,
                              subChildList: [
                               
                                {
                                  text: "Bank Summary",
                                  url: "/reports/bank_summary",
                                  access: ['xero_bank_summary'],
                                },
                                {
                                  text: "Budget Summary",
                                  url: "/reports/budget_summary",
                                  access: ['xero_budget_summary'],
                                },
                                {
                                  text: "Executive Summary",
                                  url: "/reports/executive_summary",
                                  access: ['xero_executive_summary'],
                                },
                              ]
                            },
                            {
                              type:"SUB_MENU",
                              text: "Tax Reports",
                              access: ['xero_sales_tax', 'zatca_tax_report'],
                              func: any,
                              subChildList: [
                                {
                                  text: "Sales Tax Report",
                                  url: "/reports/sales_tax",
                                  access: ['xero_sales_tax'],
                                },
                                {
                                  text: "Zatca Tax Report",
                                  url: "/reports/zatca",
                                  access: ['zatca_tax_report'],
                                },
                                {
                                  text: "Reported Documents",
                                  url: "/reports/reported_documents",
                                  access: ['zatca_tax_report'],
                                  isNew:true
                                },
                              ]
                            },
                            {
                              type:"SUB_MENU",
                              text: "Transactions",
                              subChildList: [
                                {
                                  text: "Contact Transactions",
                                  url: "/reports/contact_transactions",
                                },
                                {
                                  text: "Payable & Receivable Detail",
                                  url: "/reports/payable_receivable/detail",
                                },
                                {
                                  text: "Payables-Receivables",
                                  url: "/reports/payables_receivables",
                                  access: ['xero_payable_receivable'],
                                },
                              ]
                            },
                          ]} />
                        </li>

                        <li>
                          <LiItemDropdown text="Charts" icon="dashboard" url="/charts" srcImg="/images/settings-icon.svg" dropdown={true} access={['xero_balance_sheet', 'xero_balance_sheet', 'xero_profit_and_loss', 'xero_payable_receivable', 'expense_report']} childList={[
                            {
                              text: "Bank Balance",
                              url: "/charts/bankbalance",
                              access: ['xero_balance_sheet'],
                            },
                            {
                              text: "Balance Chart",
                              url: "/charts/balancechart",
                              access: ['xero_balance_sheet'],
                            },
                            {
                              text: "Profit And Loss",
                              url: "/charts/profit_loss",
                              access: ['xero_profit_and_loss'],
                            },
                            {
                              text: "Expenses",
                              url: "/charts/expenses",
                              access: ['expense_report'],
                            },
                            {
                              text: "Sales and Purchases",
                              url: "/charts/receivable_payable",
                              access: ['xero_payable_receivable'],
                            },
                          ]} />
                        </li>

                        <li>
                          <LiItemDropdown text="Contacts" icon="contacts" url="/contacts" srcImg="/images/contacts.svg" dropdown={true} access={['xero_contacts']} childList={[
                            {
                              text: "Contacts",
                              url: "/contacts",
                              access: ['xero_contacts'],
                            },
                            {
                              text: "Customers",
                              url: "/customers?isCustomer=true",
                              access: ['xero_contacts'],
                            },
                            {
                              text: "Suppliers",
                              url: "/suppliers?isSupplier=true",
                              access: ['xero_contacts'],
                            },
                            {
                              text: "Manage Groups",
                              url: "/contact_groups",
                              access: ['xero_contacts'],
                            },
                          ]} />
                        </li>
                        <li>
                          <LiItemDropdown text="Audit Report" icon="audit-report" url="/reports/audit_reports" srcImg="/images/audit-report.svg" dropdown={false} childList={[]} access={['xero_reports']} />
                        </li>
                        <li>
                          <LiItemDropdown text="Settings" icon="settings" url="/accounting/settings" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} access={['xero_settings']} />
                        </li>

                      </>
                    )}
                  </>
                )}
                {isPayroll && (
                  <>
                    {selectedSection === "payroll" && (
                      <>
                        <li>
                          <LiItemDropdown text="Dashboard" icon="dashboard" url="/payroll/dashboard" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} access={['hr_payroll_dashboard']} />
                        </li>

                        <li>
                          <LiItemDropdown text="Pay Runs" icon="payruns" url="/payroll/pay_runs" dropdown={false} childList={[]} access={['hr_payruns']} func={all} />
                        </li>

                        <li>
                          <LiItemDropdown text="Payment Reports" icon="reports" url="/payroll/tracks" dropdown={false} childList={[]} access={['hr_payroll']} func={all} />
                        </li>

                        <li>
                          <LiItemDropdown text="Loans" icon="loans" url="/payroll/loans" dropdown={false} childList={[]} access={['hr_loans']} func={all} />
                        </li>
                        <li>
                          <LiItemDropdown text="Employee" icon="employees" url="/payroll/employees" dropdown={false} access={['hr_payroll']} childList={[]} func={all} />
                        </li>
                        <li>
                          <LiItemDropdown text="Contracts" icon="contracts" url="/payroll-new/contracts" dropdown={false} access={['hr_payroll']} childList={[]} func={all} />
                        </li>
                        <li>
                          <LiItemDropdown text="Time off" icon="time-off" url="/payroll/time_off" dropdown={false} childList={[]} access={['hr_timeoff']} func={all} />
                        </li>
                        <li>
                          <LiItemDropdown text="Attendance Report" icon="attendance" url="/payroll-new/attendance-report" dropdown={false} childList={[]} access={['hr_payroll']} />
                        </li>
                        <li>
                          <LiItemDropdown text="Shift Assignment" icon="shift-assignment" url="/payroll-new/assignment-shift" dropdown={false} childList={[]} access={['hr_payroll']} />
                        </li>
                        <li>
                          <LiItemDropdown text="End Of Service" icon="payruns" url="/payroll-new/end-of-service" dropdown={false} childList={[]} access={['hr_payroll']} />
                        </li>
                        <li>
                          <LiItemDropdown text="Settings" icon="settings" url="/payroll-new/settings" dropdown={false} childList={[]} access={['hr_settings']} func={all} />
                        </li>

                      </>
                    )}
                  </>
                )}
                {employee && selectedSection === "portal" && (
                  <>
                    <li>
                      <LiItemDropdown text="Portal" icon="dashboard" url="/employee_payroll" dropdown={false} childList={[]} />
                    </li>
                    <li>
                      <LiItemDropdown text="Contracts " icon="contracts" url="/employee_payroll/contracts" srcImg="/images/settings-icon.svg" dropdown={false} childList={[]} />
                    </li>
                    <li>
                      <LiItemDropdown text="Loans" icon="loans" url="/employee_payroll/loans" dropdown={false} childList={[]} />
                    </li>
                    <li>
                      <LiItemDropdown text="Holidays" icon="time-off" url="/employee_payroll/holidays" dropdown={false} childList={[]} />
                    </li>
                  </>
                )}
                {selectedSection === "tasks" && (
                  <>
                    <li>
                      <LiItemDropdown text="Tasks Management" icon="dashboard" url="task-management" dropdown={false} childList={[]} />
                    </li>
                  </>
                )
                }
                {selectedSection === "tasks" && !employee && (
                  <>
                    <li>
                      <LiItemDropdown text="Re-Assign Requests" icon="reassign" url="re-assign-requests" srcImg="/images/reassign-task.svg" dropdown={false} childList={[]} />
                    </li>
                  </>
                )
                }
                {selectedSection === "tasks" && !employee && (
                  <>
                    <li>
                      <LiItemDropdown text="Groups" icon="groups" url="groups" srcImg="/images/groups-svgrepo-com.svg" dropdown={false} childList={[]} />
                    </li>
                  </>
                )
                }
                {selectedSection === "tasks" && !employee && (
                  <>
                    <li>
                      <LiItemDropdown text="Labels" icon="labels" url="labels" srcImg="/images/task-label.svg" dropdown={false} childList={[]} />
                    </li>
                  </>
                )
                }
                {isAccounting && (
                  <>
                    {selectedSection === "users" && (
                      <>
                        <li>
                          <LiItemDropdown text="Users" icon="employee" dropdown={true} access={userAndSubsPerms} childList={[
                            {
                              text: "All Users",
                              url: "/allusers",
                            },
                            {
                              text: "Xero Users",
                              url: "/userspage",
                            },
                            {
                              text: "Local Users",
                              url: "/userslist",
                            },
                          ]} />
                        </li>
                        <li>
                          <LiItemDropdown text="HR & Payroll" icon="time-off" url="/payroll/dashboard" dropdown={false} childList={[]} access={['hr_payroll', 'hr_settings']} func={all} />
                        </li>
                      </>
                    )}
                  </>
                )}
                {collapsedSidebar === false ?
                  <div onClick={switchCollapse} style={{ cursor: "pointer", marginTop: "20px", marginInlineStart: "20px" }}>
                    <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M9.33433 5.60714L19.3333 5.60714C19.5985 5.60714 19.8529 5.74825 20.0404 5.99941C20.2279 6.25058 20.3333 6.59123 20.3333 6.94643C20.3333 7.30163 20.2279 7.64228 20.0404 7.89345C19.8529 8.14461 19.5985 8.28571 19.3333 8.28571L9.33433 8.28571C9.06914 8.28571 8.81481 8.14461 8.62729 7.89345C8.43977 7.64228 8.33443 7.30163 8.33443 6.94643C8.33443 6.59123 8.43977 6.25058 8.62729 5.99941C8.81481 5.74825 9.06914 5.60714 9.33433 5.60714ZM9.33433 10.9643L19.3333 10.9643C19.5985 10.9643 19.8529 11.1054 20.0404 11.3566C20.2279 11.6077 20.3333 11.9484 20.3333 12.3036C20.3333 12.6588 20.2279 12.9994 20.0404 13.2506C19.8529 13.5018 19.5985 13.6429 19.3333 13.6429H9.33433C9.06914 13.6429 8.81481 13.5018 8.62729 13.2506C8.43977 12.9994 8.33443 12.6588 8.33443 12.3036C8.33443 11.9484 8.43977 11.6077 8.62729 11.3566C8.81481 11.1054 9.06914 10.9643 9.33433 10.9643ZM1.33511 16.3214L19.3333 16.3214C19.5985 16.3214 19.8529 16.4625 20.0404 16.7137C20.2279 16.9649 20.3333 17.3055 20.3333 17.6607C20.3333 18.0159 20.2279 18.3566 20.0404 18.6077C19.8529 18.8589 19.5985 19 19.3333 19L1.33511 19C1.06992 19 0.81559 18.8589 0.628073 18.6077C0.440556 18.3566 0.335209 18.0159 0.335209 17.6607C0.335209 17.3055 0.440556 16.9649 0.628073 16.7137C0.81559 16.4625 1.06992 16.3214 1.33511 16.3214ZM19.3333 2.92857L1.33511 2.92857C1.06992 2.92857 0.81559 2.78747 0.628073 2.5363C0.440556 2.28514 0.335209 1.94448 0.335209 1.58928C0.335209 1.23409 0.440556 0.893433 0.628073 0.642267C0.81559 0.391102 1.06992 0.25 1.33511 0.25L19.3333 0.25C19.5985 0.25 19.8529 0.391102 20.0404 0.642267C20.2279 0.893433 20.3333 1.23409 20.3333 1.58928C20.3333 1.94448 20.2279 2.28514 20.0404 2.5363C19.8529 2.78747 19.5985 2.92857 19.3333 2.92857Z" fill="#A3AED0" />
                      <path d="M2.69498 12.8795C2.79373 13.0074 2.91109 13.1067 3.03975 13.1711C3.16841 13.2356 3.30561 13.2639 3.44279 13.2542C3.57997 13.2445 3.71418 13.197 3.83706 13.1148C3.95994 13.0325 4.06885 12.9172 4.157 12.7761C4.24514 12.635 4.31063 12.471 4.34938 12.2945C4.38813 12.118 4.39931 11.9327 4.38222 11.7501C4.36513 11.5675 4.32014 11.3917 4.25005 11.2334C4.17996 11.0752 4.08628 10.938 3.97485 10.8304L2.89496 9.625L3.97485 8.41964C4.0761 8.30721 4.15979 8.16913 4.22114 8.01331C4.28249 7.85749 4.32028 7.68698 4.33236 7.51157C4.34443 7.33615 4.33055 7.15927 4.29151 6.99105C4.25247 6.82283 4.18903 6.66658 4.10484 6.53125C4.01083 6.38007 3.8931 6.25849 3.76003 6.17516C3.62696 6.09182 3.33492 6.04911 3.33492 6.04911C3.33492 6.04911 2.87348 6.16604 2.69498 6.37053L0.695173 8.59375C0.581944 8.71942 0.490803 8.877 0.428246 9.05525C0.365688 9.2335 0.333252 9.42804 0.333252 9.625C0.333252 9.82196 0.365688 10.0165 0.428246 10.1948C0.490803 10.373 0.581944 10.5306 0.695173 10.6563L2.69498 12.8795Z" fill="#969696" />
                    </svg>
                    <span className="chevron-ctn" style={{ cursor: "pointer", marginInlineStart: "10px", alignItems: "center", color: "#59627f" }}>
                      <Trans> Hide Sidebar </Trans>
                    </span>
                  </div>
                  :
                  <div onClick={() => { setCollapsedSidebar(false) }} style={{ cursor: "pointer", marginTop: "20px", marginInlineStart: "20px" }}>
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M10.9989 13.6429L0.9999 13.6429C0.734709 13.6429 0.48038 13.5018 0.292862 13.2506C0.105344 12.9994 -2.16962e-06 12.6588 -2.10751e-06 12.3036C-2.04541e-06 11.9484 0.105345 11.6077 0.292863 11.3566C0.480381 11.1054 0.73471 10.9643 0.9999 10.9643L10.9989 10.9643C11.2641 10.9643 11.5184 11.1054 11.706 11.3566C11.8935 11.6077 11.9988 11.9484 11.9988 12.3036C11.9988 12.6588 11.8935 12.9994 11.706 13.2506C11.5184 13.5018 11.2641 13.6429 10.9989 13.6429ZM10.9989 8.28572L0.999901 8.28571C0.73471 8.28571 0.480381 8.14461 0.292863 7.89345C0.105345 7.64228 -1.23295e-06 7.30163 -1.17084e-06 6.94643C-1.10874e-06 6.59123 0.105345 6.25058 0.292864 5.99941C0.480382 5.74825 0.734711 5.60714 0.999901 5.60714L10.9989 5.60714C11.2641 5.60714 11.5184 5.74825 11.706 5.99941C11.8935 6.25058 11.9988 6.59123 11.9988 6.94643C11.9988 7.30163 11.8935 7.64228 11.706 7.89345C11.5184 8.14461 11.2641 8.28572 10.9989 8.28572ZM18.9981 2.92857L0.999902 2.92857C0.734711 2.92857 0.480382 2.78747 0.292864 2.5363C0.105346 2.28514 -2.96273e-07 1.94449 -2.34168e-07 1.58929C-1.72063e-07 1.23409 0.105346 0.893433 0.292864 0.642268C0.480383 0.391103 0.734712 0.25 0.999902 0.25L18.9981 0.250003C19.2633 0.250003 19.5177 0.391107 19.7052 0.642271C19.8927 0.893436 19.998 1.23409 19.998 1.58929C19.998 1.94449 19.8927 2.28514 19.7052 2.53631C19.5177 2.78747 19.2633 2.92857 18.9981 2.92857ZM0.999899 16.3214L18.9981 16.3214C19.2633 16.3214 19.5177 16.4625 19.7052 16.7137C19.8927 16.9649 19.998 17.3055 19.998 17.6607C19.998 18.0159 19.8927 18.3566 19.7052 18.6077C19.5177 18.8589 19.2633 19 18.9981 19L0.999899 19C0.734708 19 0.480379 18.8589 0.292861 18.6077C0.105343 18.3566 -3.10629e-06 18.0159 -3.04419e-06 17.6607C-2.98208e-06 17.3055 0.105344 16.9649 0.292862 16.7137C0.48038 16.4625 0.734709 16.3214 0.999899 16.3214Z" fill="#A3AED0" />
                      <path d="M17.6383 6.37054C17.5395 6.24263 17.4222 6.14335 17.2935 6.07888C17.1648 6.01441 17.0276 5.98615 16.8905 5.99585C16.7533 6.00555 16.6191 6.053 16.4962 6.13525C16.3733 6.2175 16.2644 6.33278 16.1763 6.4739C16.0881 6.61502 16.0226 6.77896 15.9839 6.95548C15.9451 7.132 15.9339 7.31733 15.951 7.49989C15.9681 7.68246 16.0131 7.85835 16.0832 8.01659C16.1533 8.17484 16.247 8.31204 16.3584 8.41965L17.4383 9.625L16.3584 10.8304C16.2571 10.9428 16.1735 11.0809 16.1121 11.2367C16.0508 11.3925 16.013 11.563 16.0009 11.7384C15.9888 11.9138 16.0027 12.0907 16.0417 12.259C16.0808 12.4272 16.1442 12.5834 16.2284 12.7188C16.3224 12.8699 16.4402 12.9915 16.5732 13.0748C16.7063 13.1582 16.9983 13.2009 16.9983 13.2009C16.9983 13.2009 17.4598 13.084 17.6383 12.8795L19.6381 10.6563C19.7513 10.5306 19.8424 10.373 19.905 10.1948C19.9676 10.0165 20 9.82197 20 9.625C20 9.42804 19.9676 9.2335 19.905 9.05525C19.8424 8.877 19.7513 8.71942 19.6381 8.59375L17.6383 6.37054Z" fill="#A3AED0" />
                    </svg>
                  </div>
                }
                {/* </NavLink> */}
              </Fragment>
            )}


            {/* </ul> */}
          </Nav>
        </PerfectScrollbar>
      </div>
    </aside>
  );
}
export default Sidebar;